import { IConfigsType } from '../../types'

const originalCorporatePagesConfig: IConfigsType = {
  'fw_wingstop-corporate-base-zj8m1ewp': {
    '/:brand/corporate_delivery': {},
  },
}

export default originalCorporatePagesConfig
